(ns machtfit.core
  (:require [ajax.core :refer [POST]]
            [cljs-time.coerce :as time.coerce]
            [cljs-time.extend] ;; needed for side effects
            [clojure.walk :as walk]
            [machtfit.datetime :as datetime]
            [re-frame.core :as rf])
  (:require-macros [machtfit.core :as machtfit]))

(rf/reg-sub :get
  (fn [db [_ path]]
    (get-in db path)))

(rf/reg-event-db :set-path [rf/trim-v]
  (fn [current-db [path value]] (assoc-in current-db path value)))

(defn- decode-extra-types [data]
  (let [decode (fn [form]
                 (condp #(get %2 %1) form
                   :#D :>> time.coerce/to-date-time
                   :#DT :>> datetime/unix->date
                   :#K :>> keyword
                   :#S :>> set
                   :#KV :>> #(apply hash-map %)
                   :#DC :>> js/parseFloat
                   form))]
    (walk/postwalk decode data)))

(rf/reg-fx :redirect
  (fn [{:keys [url]}]
    (aset js/window.top.location "href" url)))

(rf/reg-fx :alert
  (fn [{:keys [msg]}]
    (js/alert msg)))

(rf/reg-fx :post
  (fn [{:keys [url data on-success on-error csrf-token response-format keywordize?]
        :or {response-format :json
             keywordize? true}}]
    (POST url
          (merge {:headers {:X-CSRFToken csrf-token}
                  :params data
                  :handler on-success
                  :error-handler (fn [err]
                                   (js/console.error "request failed"
                                                     url
                                                     (clj->js err))
                                   (when on-error
                                     (on-error err)))
                  :response-format response-format}
                 (case response-format
                   :json {:keywords? keywordize?
                          :handler (when on-success
                                     (comp on-success decode-extra-types))}
                   :transit {:handlers {"f" js/parseFloat
                                        "D" time.coerce/to-date-time}})))))

(rf/reg-event-fx :redirect
  (fn [_ [_ url]]
    {:redirect {:url url}}))

(defonce ^:private debounce-timeouts
  (atom {}))

(rf/reg-fx :dispatch-debounce
  (fn dispatch-debounce [debounce]
    (let [{:keys [key
                  #_:clj-kondo/ignore delay
                  event]} debounce]
      (js/clearTimeout (@debounce-timeouts key))
      (swap! debounce-timeouts assoc key
             (js/setTimeout (fn []
                              (rf/dispatch event)
                              (swap! debounce-timeouts dissoc key))
                            delay)))))

(rf/reg-fx :clear-debounce
  (fn [key]
    (js/clearTimeout (@debounce-timeouts key))))

(defn stop-event [event]
  (doto event
    .preventDefault
    .stopPropagation))
